// Layout.js
import React, { useState } from 'react';
import Header from './Header';
import AppSidebar from './Sidebar';
import './Layout.css'; // Import your custom styles

const Layout = ({ children }) => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);

  const toggleSidebar = () => {
    setIsSidebarOpen((prev) => !prev);
  };

  return (
    <div className="app-layouts">
      <Header onToggleSidebar={toggleSidebar} />
      <div className="layout-contents">
        <AppSidebar isOpen={isSidebarOpen} onClose={() => setIsSidebarOpen(false)} />
        <main className="main-contents">
          {children}
        </main>
      </div>
    </div>
  );
};

export default Layout;
